<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">

    <div class="col-lg-12" *ngIf="showAlert5 || showAlert4">
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block"
            [class.component-dark-theme]="themeService.isDark()">
            <mat-card-header>
                <mat-card-title>
                    <h5 class="mb-0">
                        {{ currentLang === 'or' ? 'ସତର୍କତା ବାର୍ତ୍ତା' : 'Dismissing Alerts' }}
                    </h5>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content class="example-alerts">
                @if (showAlert) {
                <div class="alert alert-daxa d-flex justify-content-between align-items-center" role="alert">
                    A simple daxa alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert2) {
                <div class="alert alert-primary d-flex justify-content-between align-items-center" role="alert">
                    A simple primary alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert2()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert3) {
                <div class="alert alert-secondary d-flex justify-content-between align-items-center" role="alert">
                    A simple secondary alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert3()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert4) {
                <div class="alert alert-success d-flex justify-content-between align-items-center" role="alert">
                    <div class="d-flex align-items-center">
                        <mat-icon class="me-2">check_circle</mat-icon>
                        <span>{{alertMessage}}</span>
                    </div>
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert4()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert5) {
                <div class="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
                    <div class="d-flex align-items-center">
                        <mat-icon class="me-2">error</mat-icon>
                        <span>{{alertMessage}}</span>
                    </div>
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert5()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert6) {
                <div class="alert alert-warning d-flex justify-content-between align-items-center" role="alert">
                    A simple warning alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert6()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert7) {
                <div class="alert alert-info d-flex justify-content-between align-items-center" role="alert">
                    A simple info alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert7()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert8) {
                <div class="alert alert-light d-flex justify-content-between align-items-center" role="alert">
                    A simple light alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert8()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
                @if (showAlert9) {
                <div class="alert alert-dark d-flex justify-content-between align-items-center" role="alert">
                    A simple dark alert—check it out!
                    <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                        aria-label="Close" (click)="dismissAlert9()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
            </mat-card-content>
        </mat-card>
    </div>
</div>